
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import AccessForm from "@/form/salonGeneral/access";

@Component({
    components: {FormGroup},
})
export default class AccessServiceAddForm extends Vue {
    @Prop() form!: AccessForm;

    async created(): Promise<void> {
        console.log('creted');
    }
}
